<template>
  <div>
    <v-container>
      <!-- <div>
        <date-filter
          @changeDate="getData"
          :defaultFilter="'today'"
          v-model="selectedDate"
        ></date-filter>
      </div> -->
      <div class="mt-3">
        <div class="title mb-3">จำนวนและรายชื่อช่างที่ลงทะเบียนสำเร็จ</div>
        <v-layout row wrap class="mb-0">
          <v-flex xs7>
            <v-pagination
              @input="changepage"
              v-model="page"
              :length="pagelength"
              :total-visible="7"
            ></v-pagination>
            <!-- <div>
              <multiselect
                v-model="dealertype"
                label="label"
                :allow-empty="false"
                single-select
                :options="optionType"
                @input="getData"
              ></multiselect>
            </div> -->
          </v-flex>
          <v-flex xs5 class="pt-3">
            <div class="text-xs-right">ทั้งหมด : {{ total }}</div></v-flex
          >
        </v-layout>

        <v-data-table
          v-bind:pagination.sync="pagination"
          :headers="headers"
          :items="data"
          class="elevation-1"
          hide-actions
          :loading="loading"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">
                {{ props.item.painter_name }}
              </td>
              <td class="text-xs-center">
                {{ props.item.painter_phoneno }}
              </td>
              <td class="text-xs-center">
                {{ props.item.painter_email }}
              </td>
              <td class="text-xs-center">
                <div v-for="(item, k) in props.item.painter_experience" :key="k">
                  {{ item }}
                </div>
              </td>
              <td class="text-xs-center">
                <div>
                  {{
                    `${props.item.painter_address1} เขต${props.item.painter_sub_district} แขวง${props.item.painter_district} จังหวัด${props.item.painter_province} เลขไปรษณีย์${props.item.painter_zip_code} `
                  }}
                </div>
              </td>
              <td class="text-xs-center">
                <div>
                  <v-btn
                    :disabled="!props.item.painter_works || !props.item.painter_works.length"
                    @click="showImageWork(props.item.painter_works)"
                  >
                    <em class="fas fa-image mr-2" /> ดูรูปผลงาน ({{
                      props.item.painter_works ? props.item.painter_works.length : 0
                    }})
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-container>
    <div v-if="showImage">
      <Tinybox v-model="index" :images="currentImages" loop />
    </div>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Tinybox from 'vue-tinybox'
import Multiselect from 'vue-multiselect'
export default {
  components: {
    DateFilter,
    Multiselect,
    Tinybox
  },
  data() {
    return {
      currentImages: [],
      showImage: false,
      index: null,
      limit: 10,
      page: 1,
      pagetmp: 1,
      pagetotal: 0,
      offset: 0,

      dealertype: {
        label: 'ร้านค้าที่ส่งใบประเมินราคาให้ลูกค้า',
        value: 'dealersendquotationdashboard'
      },
      optionType: [
        {
          label: 'ร้านค้าที่ส่งใบประเมินราคาให้ลูกค้า',
          value: 'dealersendquotationdashboard'
        },
        {
          label: 'ร้านค้าที่การชำระเงินสำเร็จ',
          value: 'dealersendquotationdashboard'
        },
        {
          label: 'ร้านค้าที่จัดส่งสำเร็จ',
          value: 'dealersendquotationdashboard'
        },
        {
          label: 'ร้านค้าที่ลงทะเบียนสำเร็จ',
          value: 'dealersendquotationdashboard'
        }
      ],
      loading: false,
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      data: [],
      total: 0,
      headers: [{ text: 'ชื่อช่าง', value: 'name', align: 'center', width: '1%' }]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.pagetotal) {
        return Math.ceil(this.pagetotal / this.limit)
      } else {
        return 1
      }
    }
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    showImageWork(images) {
      this.currentImages = images
      this.showImage = true
      this.index = 0
    },
    changepage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        this.getData()
      }
    },
    getData() {
      var vm = this
      return new Promise((resolve) => {
        vm.offset = vm.page * 10 - 10
        if (vm.page != 1) {
          vm.offset + 1
        }
        var data = {
          pageid: this.selectedBot.pageid,
          limit: this.limit,
          offset: this.offset
          // datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
          // dateto: moment(this.selectedDate.end).format('YYYY-MM-DD'), // YYYY-MM-DD
        }
        this.loading = true
        api['painterregistersuccessdashboard'](data, (err, response) => {
          this.loading = false
          try {
            this.data = response.data.map((el) => {
              return JSON.parse(el.painterinfo)
            })
          } catch (error) {
            this.data = []
          }
          if (response.total) {
            this.total = response.total
          } else {
            this.total = 0
          }
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toa/Painter/painterregistersuccessdashboard.vue